var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEoySelfAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FFF4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#FFF4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5671 13.3088L17.3171 7.05879C17.2298 6.97133 17.1184 6.91174 16.9972 6.88756C16.876 6.86338 16.7503 6.87569 16.6361 6.92294C16.5218 6.97019 16.4242 7.05025 16.3555 7.153C16.2867 7.25576 16.25 7.37658 16.25 7.5002V10.6525C14.2234 10.826 11.9851 11.8182 10.1437 13.3799C7.92651 15.2611 6.54605 17.6854 6.2562 20.2057C6.23355 20.4016 6.27328 20.5997 6.36974 20.7718C6.46619 20.9438 6.61446 21.0811 6.79343 21.164C6.97241 21.2469 7.17298 21.2712 7.36659 21.2336C7.56021 21.1959 7.73701 21.0981 7.87183 20.9541C8.7312 20.0393 11.789 17.1463 16.25 16.8916V20.0002C16.25 20.1238 16.2867 20.2446 16.3555 20.3474C16.4242 20.4501 16.5218 20.5302 16.6361 20.5775C16.7503 20.6247 16.876 20.637 16.9972 20.6128C17.1184 20.5887 17.2298 20.5291 17.3171 20.4416L23.5671 14.1916C23.684 14.0744 23.7497 13.9157 23.7497 13.7502C23.7497 13.5847 23.684 13.426 23.5671 13.3088ZM17.5 18.4916V16.2502C17.5 16.0844 17.4341 15.9255 17.3169 15.8083C17.1997 15.691 17.0407 15.6252 16.875 15.6252C14.6812 15.6252 12.5445 16.1979 10.5242 17.3283C9.49522 17.9066 8.53652 18.6019 7.66714 19.4002C8.12026 17.5377 9.26245 15.7666 10.9523 14.333C12.7664 12.7947 14.9804 11.8752 16.875 11.8752C17.0407 11.8752 17.1997 11.8094 17.3169 11.6921C17.4341 11.5749 17.5 11.416 17.5 11.2502V9.00957L22.2414 13.7502L17.5 18.4916Z",
    fill: "#ED6C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEoySelfAssessment);
export default __webpack_public_path__ + "static/media/eoy-self-assessment.0ad2d744ace20e0d6e5f68dddb715e24.svg";
export { ForwardRef as ReactComponent };